<template>
  <!-- 顶部Logo -->
  <div class="big-block">
    <div class="small-block1"></div>
    <div class="small-block2">
      <img
        src="@/assets/LogoImages/Top-logo1.png"
        alt="Image 1"
        class="image1"
      />
      <img
        src="@/assets/LogoImages/Top-logo2.png"
        alt="Image 2"
        class="image2"
      />
    </div>
    <div class="small-block3"></div>
  </div>
</template>

<script>
export default {
  name: 'TopImages',
};
</script>

<style scoped>
/* 重置默认的外边距和内边距 */
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box; /* 包括padding和border在内的宽度 */
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden; /* 防止水平滚动条 */
}

.big-block {
  display: flex;
  flex-direction: row; /* 水平排列三个块 */
  justify-content: space-between;
  width: 1200px; /* 固定宽度 */
  height: 166px; /* 固定高度 */
  background-color: blue;
  z-index: 10;
  margin: 0 auto; /* 水平居中 */
}

.small-block1,
.small-block3 {
  width: 130px; /* 固定宽度 */
  height: 100%;
  background-color: blue;
}

.small-block2 {
  display: flex;
  flex-direction: column;
  flex-grow: 0; /* 防止自动填充剩余空间 */
  background-color: blue;
  justify-content: center; /* 使图片垂直居中 */
  padding-left: 20px; /* 给图片左侧一些间距 */
  padding-right: 20px; /* 给图片右侧一些间距 */
}

.image1 {
  width: auto; /* 图片宽度自适应 */
  max-width: 277px; /* 最大宽度限制 */
  height: 54px; /* 固定高度 */
  margin-top: 20px;
  object-fit: contain; /* 确保图片自适应并保持比例 */
}

.image2 {
  width: 100%; /* 图片宽度占满剩余空间 */
  height: auto; /* 高度自适应 */
  margin-top: auto;
  margin-bottom: 5px;
  object-fit: contain; /* 确保图片自适应并保持比例 */
}

/* 媒体查询：当屏幕宽度小于 768px 时调整图片大小和容器布局 */
@media (max-width: 768px) {
  .big-block {
    height: 120px; /* 在小屏幕上减少导航栏高度 */
  }

  .small-block1,
  .small-block3 {
    width: 80px; /* 减小左右边栏宽度 */
  }

  .small-block2 {
    padding-left: 10px; /* 缩小左边距 */
    padding-right: 10px; /* 缩小右边距 */
  }

  .image1 {
    width: auto; /* 自适应宽度 */
    max-width: 200px; /* 限制图片的最大宽度 */
    height: 40px; /* 适应小屏幕时的高度 */
  }

  .image2 {
    width: 100%; /* 图片宽度占满剩余空间 */
    height: auto; /* 高度自适应 */
    margin-top: auto;
    margin-bottom: 5px;
  }
}

/* 媒体查询：当屏幕宽度小于 480px 时进一步调整 */
@media (max-width: 480px) {
  .big-block {
    height: 100px; /* 在更小屏幕上进一步减少高度 */
  }

  .small-block1,
  .small-block3 {
    width: 60px; /* 进一步减小左右边栏宽度 */
  }

  .small-block2 {
    padding-left: 5px; /* 更小的左边距 */
    padding-right: 5px; /* 更小的右边距 */
  }

  .image1 {
    width: auto; /* 自适应宽度 */
    max-width: 150px; /* 限制图片的最大宽度 */
    height: 30px; /* 更小的图片高度 */
  }

  .image2 {
    width: 100%; /* 图片宽度占满剩余空间 */
    height: auto; /* 高度自适应 */
    margin-top: auto;
    margin-bottom: 5px;
  }
}
</style>
